module.exports = __webpack_public_path__ + "media/images/worksapp-logo-babd2dc3.jpg";